import React from 'react';
import { Panel } from '../../../../components/containers/Panel';
import { PanelHeader } from '../../../../components/containers/Panel/PanelHeader.view';
import classes from '../LinkTracking.module.scss';
import { Select } from '../../../../components/forms/Select';
import { Toggle } from '../../../../components/forms/Toggle';
import { LinkTrackingSocialProfileList } from '../LinkTrackingSocialProfileList';
import { useForm } from 'react-hook-form';
import { FormOptions } from '../../../../constants/form';
import { SelectItem } from '../../../../components/forms/Select/Select.view';
import { UpdateCustomBitlySettingsInput, CustomBitlySettingsValuesInput } from '../../../../models/graphql';
import { GetBitlyAccounts_workspace_socialProfiles } from '../../../../models/legacy-graphql';
import { ToggleAction } from '../../../../components/forms/Toggle/Toggle.controller';
import { LinkTrackingSocialProfilesListProps } from '../LinkTrackingSocialProfileList/LinkTrackingSocialProfilesList.view';
import { FormElementAction } from '../../../../models/basic-objects';

export type LinkTrackingPreferencesPanelViewProps = {
  loading: boolean;
  getDefaultBitlyDomainListSelectItems: () => Array<SelectItem>;
  getBitlyDomainListSelectItems: (profileId: string) => Array<SelectItem>;
  getDefaultBitlyInputValue: () => CustomBitlySettingsValuesInput;
  getCustomBitlySettingsValueInput: (profileId: string) => UpdateCustomBitlySettingsInput;
  socialProfiles: GetBitlyAccounts_workspace_socialProfiles[];
  showCustomLinkTracking: boolean;
  setShowCustomLinkTracking: (show: boolean) => void;
  defaultBitlyDomainSelectHandler: FormElementAction;
  customLinkTrackingToggleHandler: ToggleAction;
  customBitlyDomainSelectHandler: FormElementAction;
};

export const LinkTrackingPreferencesPanelView = (props: LinkTrackingPreferencesPanelViewProps): JSX.Element => {
  const useFormInstance = useForm({
    ...FormOptions
  });

  const profileListGroupPropsValues: LinkTrackingSocialProfilesListProps = {
    loading: props.loading,
    socialProfiles: props.socialProfiles,
    getBitlyDomainListSelectItems: props.getBitlyDomainListSelectItems,
    getCustomBitlySettingsValueInput: props.getCustomBitlySettingsValueInput,
    customBitlyDomainSelectHandler: props.customBitlyDomainSelectHandler
  };
  const selectItems = props.getDefaultBitlyDomainListSelectItems() || [];
  const defaultBitlySelectedValue = props.getDefaultBitlyInputValue();

  return (
    <Panel>
      <PanelHeader
        title={'Bitly Preferences'}
        tooltip={
          'You can choose which Bitly account and short-domain will be used to shorten and track all newly-added links, or you can turn link tracking off by default. This setting can be customized for each profile; and you can always override this when editing individual Posts.'
        }
      />
      <div className={'grid-x margin-bottom-small-24'}>
        <div className={`cell small-12 large-6 ${classes.Label}`}>Default Link Tracking</div>
        <div className={'cell small-12 large-6'}>
          <Select
            items={selectItems}
            name={'defaultLinkTracking'}
            rules={{}}
            size={'large'}
            useFormInstance={useFormInstance}
            selectedValue={JSON.stringify(defaultBitlySelectedValue)}
            action={(value, complete) => props.defaultBitlyDomainSelectHandler(value, complete)}
          />
        </div>
      </div>
      {props.socialProfiles.length > 0 && (
        <>
          <div className={'cell small-6 margin-bottom-small-24 margin-bottom-large-32'}>
            <Toggle
              formInstance={useFormInstance}
              name={'customLinkTrackingToggle'}
              rules={{}}
              label={'Customize per Profile'}
              action={(value, complete) => props.customLinkTrackingToggleHandler(value, complete)}
              checked={props.showCustomLinkTracking}
            />
          </div>
          {props.showCustomLinkTracking && (
            <div>
              <LinkTrackingSocialProfileList {...profileListGroupPropsValues} />
            </div>
          )}
        </>
      )}
    </Panel>
  );
};
